@use "../../styles/breakpoint.module.scss" as *;

.root {
    --progress: 0%;

    position: relative;
    display: flex;
    flex-direction: column;
    z-index: 0;

    &::before {
        --overall-height: 100px;
        --visible-height: 5px;

        content: "";
        position: sticky;
        top: calc(100vh - var(--overall-height));
        left: 0;
        width: calc(var(--progress) / 2);
        height: var(--overall-height);
        background: conic-gradient(
            from var(--xcient-gradient-deg) at var(--xcient-gradient-position),
            var(--xcient-gradient-stops)
        );
        clip-path: inset(calc(100px - var(--visible-height)) 0 0 0);
        animation: spin-gradient 10s linear infinite;
        transition: width 0.3s;
        z-index: 1;

        @media ($below-mobile) {
            background: var(--white);
            width: var(--progress);
        }
    }

    &::after {
        content: "";
        position: absolute;
        right: 0;
        width: 50%;
        height: 100%;
        background: var(--xcient-gradient);

        @media ($above-mobile) {
            top: 0;
            height: 100%;
            z-index: -1;
        }

        @media ($below-mobile) {
            display: none;
        }
    }

    @media ($below-mobile) {
        background: var(--xcient-gradient);
    }
}

.match {
    composes: root;
    composes: match from "../../styles/theming.module.css";
}

.contrast {
    composes: root;
    composes: contrast from "../../styles/theming.module.css";
}

.dummyCard {
    height: 100vh;
}

.wrapper {
    display: flex;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;

    @media ($below-mobile) {
        flex-direction: column;
    }
}

.featureMedia {
    position: relative;
    width: 50%;
    transition: opacity 0.3s;

    @media ($below-mobile) {
        width: 100%;
        aspect-ratio: 4 / 3;
    }

    & :is(img, video) {
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        object-fit: contain;
    }
}

.card {
    composes: darkBase from "../../styles/theming.module.css";
    position: relative;
    display: flex;
    justify-content: center;
    flex-direction: column;
    padding-left: var(--spacer-56);
    padding-right: var(--labui-container-margin);
    color: var(--color-contrast);
    z-index: 1;

    @media ($above-mobile) {
        width: 50%;
    }

    @media ($below-mobile) {
        width: 100%;
        padding: var(--spacer-56) var(--labui-container-margin) 0;
    }
}

.cardMedia {
    position: relative;
}

.cardTitle {
    margin-top: var(--spacer-24);
    font: var(--font-h-20);

    + .cardSubtitle {
        padding-top: var(--spacer-16);
        border-top: 1px solid var(--color-contrast);
    }
}

.cardSubtitle {
    margin-top: var(--spacer-24);
}
